<template>
  <div class="internal-thread__container">
    <!-- Activity Communications Start -->
    <section name="activity" v-if="isShowCustomerThread" class="mt-3">
      <label class="internal-thread__text--header"
        ><b>Activity Communication</b> (Reply to Customer)</label
      >
      <template v-if="activityCommunityList.length">
        <div
          v-for="(activity, index) in activityCommunityList"
          :key="index"
          class="detail__container"
        >
          <div class="d-flex w-100 justify-content-between">
            <div class="d-flex flex-column">
              <label class="detail__text--name">
                (#{{ index + 1 }}) {{ activity.name }}
                <span
                  v-if="activity.name === userFullName"
                  class="text-color-grey text-size-12"
                >
                  [You]
                </span>
              </label>
              <label class="detail__text--detail mb-0">
                {{ activity.detail }}
              </label>
            </div>
            <div class="d-flex flex-column align-items-end pl-1">
              <label class="detail__text--datetime text-right">{{
                activity.datetime
              }}</label>
            </div>
          </div>
          <div>
            <atom-file-attachment-list
              :attachmentList="activity.attachments"
              :isDeletable="status !== 'CLOSED'"
              @onRequestDeleteAttachment="
                onRequestDeleteAttachment($event, activity)
              "
            ></atom-file-attachment-list>
          </div>
        </div>
      </template>
      <template
        v-else-if="!activityCommunityList.length && !hasUpdatePermission"
      >
        <div
          class="detail__container d-flex justify-content-center align-items-center"
        >
          No activity communication reply
        </div>
      </template>
    </section>

    <section
      name="reply-activity"
      v-if="isShowCustomerThread"
      class="mb-3"
    >
      <template v-if="hasUpdatePermission">
        <div v-if="!isReplyActivity">
          <div
            :class="[
              status !== 'CLOSED'
                ? 'reply-detail__container'
                : 'reply-detail__container-disabled',
            ]"
            @click="status !== 'CLOSED' ? (isReplyActivity = true) : null"
          >
            <feather-icon
              class="icon-size-24px"
              :class="[
                status !== 'CLOSED' ? ' text-primary' : 'text-disabled',
              ]"
              icon="PlusCircleIcon"
            ></feather-icon>
            <span
              :class="[
                status !== 'CLOSED'
                  ? 'reply-detail__text'
                  : 'reply-detail__text-disabled',
              ]"
              >Reply to customer</span
            >
          </div>
        </div>
        <div v-else>
          <div class="reply-detail-add__container">
            <div class="w-100 mb-1">
              <label>Reply Template</label>
              <atom-select
                v-model="replyTemplateForActivity"
                label="name"
                placeholder="Select reply template"
                :isAsterisk="true"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isClearable="false"
                :option="replyTemplateOptions"
              ></atom-select>
            </div>
            <div class="reply-detail__input-message w-100">
              <atom-text-area
                v-model="activity.message"
                placeholder="Message"
                :isError="isErrorActivity"
                :isResizable="true"
                errorMessage="Please enter message"
              ></atom-text-area>
            </div>
            <div class="reply-detail__select-file">
              <atom-file-attachment-input
                id="replyToCustomerAttachment"
                title="Attachments (Max. 25Mb)"
                @onUpdateFile="onUpdateReplyToCustomerAttachment"
              ></atom-file-attachment-input>
            </div>
            <div class="sent-to__state">
              <atom-checkbox
                v-model="activity.isCloseTicket"
                title="Close Ticket"
              ></atom-checkbox>
            </div>
            <div class="reply-detail__button w-100">
              <atom-button
                buttonId="reply-detail__add"
                :isOnlyIcon="true"
                iconLeft="CheckIcon"
                class="add__button"
                @click="onclickAddActivity"
              ></atom-button>
              <atom-button
                buttonId="reply-detail__cancel"
                :isOnlyIcon="true"
                iconLeft="XIcon"
                buttonStyle="border"
                buttonColor="secondary"
                @click="onClickCloseActivity"
              ></atom-button>
            </div>
          </div>
        </div>
      </template>
    </section>
    <!-- Activity Communications End-->

    <!-- Ticket Internal Thread Start -->
    <section name="internal">
      <label class="internal-thread__text--header">Internal Thread</label>
      <template v-if="internalThreadList.length">
        <div
          v-for="(thread, index) in internalThreadList"
          :key="index"
          class="detail__container"
        >
          <div class="d-flex w-100 justify-content-between">
            <div class="d-flex flex-column">
              <label class="detail__text--name">
                (#{{ index + 1 }}) {{ thread.name }}
                <span
                  v-if="thread.name === userFullName"
                  class="text-color-grey text-size-12"
                >
                  [You]
                </span>
              </label>
              <label class="detail__text--detail mb-0">{{
                thread.detail
              }}</label>
            </div>
            <div class="d-flex flex-column align-items-end pl-1">
              <label class="detail__text--datetime text-right">{{
                thread.datetime
              }}</label>
            </div>
          </div>
          <div>
            <atom-file-attachment-list
              :attachmentList="thread.attachments"
              :isDeletable="status !== 'CLOSED'"
              @onRequestDeleteAttachment="
                onRequestDeleteAttachment($event, thread)
              "
            ></atom-file-attachment-list>
          </div>
        </div>
      </template>
      <template
        v-else-if="!internalThreadList.length && !hasUpdatePermission"
      >
        <div
          class="detail__container d-flex justify-content-center align-items-center"
        >
          No internal thread reply
        </div>
      </template>
    </section>

    <section name="reply-internal">
      <template v-if="hasUpdatePermission">
        <div v-if="!isReplyInternal">
          <div
            :class="[
              status !== 'CLOSED'
                ? 'reply-detail__container'
                : 'reply-detail__container-disabled',
            ]"
            @click="status !== 'CLOSED' ? (isReplyInternal = true) : null"
          >
            <feather-icon
              class="icon-size-24px"
              :class="[
                status !== 'CLOSED' ? ' text-primary' : 'text-disabled',
              ]"
              icon="PlusCircleIcon"
            ></feather-icon>
            <span
              :class="[
                status !== 'CLOSED'
                  ? 'reply-detail__text'
                  : 'reply-detail__text-disabled',
              ]"
              >Reply to internal</span
            >
          </div>
        </div>
        <div v-else>
          <div class="reply-detail-add__container">
            <div class="w-100 mb-1">
              <label>Reply Template</label>
              <atom-select
                v-model="replyTemplateForThread"
                label="name"
                placeholder="Select reply template"
                :isAsterisk="true"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isClearable="false"
                :option="replyTemplateOptions"
              ></atom-select>
            </div>
            <div class="reply-detail__input-message w-100">
              <atom-text-area
                v-model="internal.message"
                placeholder="Message"
                :isError="isErrorInternal"
                :isResizable="true"
                errorMessage="Please enter message"
              ></atom-text-area>
            </div>
            <div class="reply-detail__select-file">
              <atom-file-attachment-input
                id="internalThreadAttachment"
                title="Attachments (Max. 25Mb)"
                @onUpdateFile="onUpdateInternalThreadAttachment"
              ></atom-file-attachment-input>
            </div>
            <div class="reply-detail__sent-to">
              <div class="sent-to__container w-100">
                <label class="sent-to__text-sent-to"
                  >Send to other Department/Person</label
                >
                <div class="d-flex justify-content-end w-100 pl-1">
                  <b-button-group>
                    <b-button
                      :variant="checkVariant('None')"
                      @click="onClickSentTo('None')"
                      >None</b-button
                    >
                    <b-button
                      :variant="checkVariant('Department')"
                      @click="onClickSentTo('Department')"
                      >Department</b-button
                    >
                    <b-button
                      :variant="checkVariant('Person')"
                      @click="onClickSentTo('Person')"
                      >Person</b-button
                    >
                  </b-button-group>
                </div>
              </div>
              <div class="sent-to__state">
                <div v-if="internal.sentTo === 'None'">
                  <atom-checkbox
                    v-model="internal.isCloseTicket"
                    title="Close Ticket"
                  ></atom-checkbox>
                </div>
                <div
                  v-if="internal.sentTo === 'Department'"
                  class="d-flex align-items-center w-100"
                >
                  <label class="sent-to__text-department pr-1"
                    >Department</label
                  >
                  <atom-select
                    v-model="internal.department"
                    label="name"
                    placeholder="Select Department"
                    :isAsterisk="true"
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    :isClearable="false"
                    :option="departmentOptions"
                  ></atom-select>
                </div>
                <div
                  v-if="internal.sentTo === 'Person'"
                  class="d-flex align-items-center w-100"
                >
                  <label class="sent-to__text-person pr-1">Person</label>
                  <atom-select
                    v-model="internal.staff"
                    label="name"
                    placeholder="Select Person"
                    :isAsterisk="true"
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    :isClearable="false"
                    :option="staffList"
                  ></atom-select>
                </div>
              </div>
            </div>
            <div class="reply-detail__button w-100">
              <atom-button
                buttonId="reply-detail__add"
                :isOnlyIcon="true"
                iconLeft="CheckIcon"
                class="add__button"
                @click="onclickAddTicketInternal"
              ></atom-button>
              <atom-button
                buttonId="reply-detail__cancel"
                :isOnlyIcon="true"
                iconLeft="XIcon"
                buttonStyle="border"
                buttonColor="secondary"
                @click="onclickCloseTicketInternal"
              ></atom-button>
            </div>
          </div>
        </div>
      </template>
    </section>
    <!-- Ticket Internal Thread End -->

    <!-- Modal Start -->
    <section name="modal">
      <molecule-modal-dialog
        modalId="ticket-detail__confirm-edit-internal"
        :isTextCenter="true"
        textTitle="Do you want to add internal thread?"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmSaveEditInternal"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="ticket-detail__confirm-cancel-edit-internal"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        buttonTextRight="Cancel"
        @clickButtonLeft="clickConfirmCancelEditInternal"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="ticket-detail__confirm-edit-activity"
        :isTextCenter="true"
        textTitle="Do you want to add activity communications?"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmSaveEditActivity"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="ticket-detail__confirm-cancel-edit-activity"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        buttonTextRight="Cancel"
        @clickButtonLeft="clickConfirmCancelEditActivity"
      ></molecule-modal-dialog>
    </section>
    <!-- Modal End-->
  </div>
</template>

<script>
import { BButtonGroup, BButton } from "bootstrap-vue"
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomFileAttachmentInput from "@/components/atoms/AtomFileAttachmentInput.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomFileAttachmentList from "@/components/atoms/AtomFileAttachmentList.vue"
import { TicketType } from "@/constants"
import { mapGetters } from "vuex"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "MoleculeInternalThread",
  components: {
    FeatherIcon,
    AtomTextArea,
    AtomFileAttachmentInput,
    BButtonGroup,
    BButton,
    AtomCheckbox,
    AtomSelect,
    AtomButton,
    MoleculeModalDialog,
    AtomFileAttachmentList,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    internalThreadList: {
      type: Array,
      required: true,
    },
    activityCommunityList: {
      type: Array,
      required: true,
    },
    currentDepartment: {
      type: Object,
      required: false,
      default: () => {},
    },
    departmentList: {
      type: Array,
      required: true,
    },
    staffList: {
      type: Array,
      required: true,
    },
    // reply template
    replyTemplateOptions: {
      type: Array,
      required: true,
    },
    hasUpdatePermission: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [mixinsValidator],
  emit: ["onClickAddTicketInternal", "onClickAddTicketActivity"],
  data() {
    return {
      modalId: null,

      // ticket
      isReplyInternal: false,
      isValidateInternal: false,
      isErrorInternal: false,

      internal: {
        message: null,
        attachment: null,
        sentTo: "Department",
        department: null,
        staff: null,
        isCloseTicket: false,
      },

      // activity communications
      isReplyActivity: false,
      isValidateActivity: false,
      isErrorActivity: false,

      activity: {
        message: null,
        attachment: null,
        isCloseTicket: false,
      },

      // department options
      departmentOptions: [],

      // reply template
      replyTemplateForThread: null,
      replyTemplateForActivity: null,
    }
  },
  computed: {
    ...mapGetters("appPermission", ["getInternalFullName"]),
    isShowCustomerThread() {
      return this.type === TicketType.NORMAL
    },
    userFullName() {
      return this.getInternalFullName
    },
  },
  watch: {
    internal: {
      deep: true,
      handler() {
        if (this.isValidateInternal) this.validateInternal()
      },
    },
    activity: {
      deep: true,
      handler() {
        if (this.isValidateActivity) this.validateActivity()
      },
    },
    replyTemplateForThread: {
      handler() {
        if (this.replyTemplateForThread)
          this.internal.message = this.replyTemplateForThread.message
      },
    },
    replyTemplateForActivity: {
      handler() {
        if (this.replyTemplateForActivity)
          this.activity.message = this.replyTemplateForActivity.message
      },
    },
    currentDepartment: {
      immediate: true,
      deep: true,
      handler() {
        if (this.departmentList && this.currentDepartment) {
          this.departmentOptions = this.departmentList.filter(
            (department) => department.id !== this.currentDepartment?.id
          )
        }
      },
    },
  },
  mounted() {
    this.internal.sentTo = "None"
    this.internal.staff = this.staffList.find((s) => s.isSupport === true)
  },
  methods: {
    // click file
    onClickFile(attachment) {
      window.open(attachment.path, attachment.fileName)
    },

    // ticket
    onclickAddTicketInternal() {
      this.isValidateInternal = true
      this.validateInternal()

      if (!this.isErrorInternal) {
        this.modalId = "ticket-detail__confirm-edit-internal"
        this.openModal(this.modalId)
      }
    },
    clickConfirmSaveEditInternal() {
      const addTicketInternal = {
        ...this.internal,
      }

      this.$emit("onClickAddTicketInternal", addTicketInternal)

      this.isReplyInternal = false
      this.setInternalToOrigin()
      this.closeModal()
    },
    onclickCloseTicketInternal() {
      this.modalId = "ticket-detail__confirm-cancel-edit-internal"
      this.openModal(this.modalId)
    },
    clickConfirmCancelEditInternal() {
      this.isReplyInternal = false
      this.setInternalToOrigin()

      this.closeModal()
    },
    setInternalToOrigin() {
      this.isValidateInternal = false
      this.isErrorInternal = false
      this.internal = {
        message: null,
        attachment: null,
        sentTo: "None",
        department: this.departmentList.find(
          (department) => department.isSupportDepartment === true
        ),
        staff: this.staffList.find((s) => s.isSupport === true),
        isCloseTicket: false,
      }
    },

    // activity
    onclickAddActivity() {
      this.isValidateActivity = true
      this.validateActivity()

      if (!this.isErrorActivity) {
        this.modalId = "ticket-detail__confirm-edit-activity"
        this.openModal(this.modalId)
      }
    },
    clickConfirmSaveEditActivity() {
      const addTicketActivity = {
        ...this.activity,
      }

      this.$emit("onClickAddTicketActivity", addTicketActivity)

      this.isReplyActivity = false
      this.setActivityToOrigin()

      this.closeModal()
    },
    onClickCloseActivity() {
      this.modalId = "ticket-detail__confirm-cancel-edit-activity"
      this.openModal(this.modalId)
    },
    clickConfirmCancelEditActivity() {
      this.isReplyActivity = false
      this.setActivityToOrigin()

      this.closeModal()
    },

    setActivityToOrigin() {
      this.isValidateActivity = false
      this.isErrorActivity = false
      this.activity = {
        message: null,
        attachment: null,
        isCloseTicket: false,
      }
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    // validate
    validateInternal() {
      if (
        !this.internal.message ||
        this.isEmptyString(this.internal.message)
      )
        this.isErrorInternal = true
      else this.isErrorInternal = false
    },
    validateActivity() {
      if (
        !this.activity.message ||
        this.isEmptyString(this.activity.message)
      )
        this.isErrorActivity = true
      else this.isErrorActivity = false
    },

    onClickSentTo(sentTo) {
      this.internal.sentTo = sentTo
    },
    checkVariant(state) {
      if (state === this.internal.sentTo) return "primary"
      else return "outline-primary"
    },

    onUpdateInternalThreadAttachment(fileList) {
      this.internal.attachment = fileList
    },

    onUpdateReplyToCustomerAttachment(fileList) {
      this.activity.attachment = fileList
    },

    onRequestDeleteAttachment(file, thread) {
      this.$emit("onRequestDeleteAttachment", file, thread)
    },

    checkIsUserMessage(threadMessageOwner) {
      return threadMessageOwner === this.userFullName
    },
  },
}
</script>

<style lang="scss" scoped>
.internal-thread__text--header {
  margin: 0;
  color: #6e6b7b;
  font-weight: 500;
  font-size: 14px;
}

section[name="internal"],
section[name="activity"] {
  .detail__container {
    margin: 10px 0 0 0;
    padding: 1rem;
    width: 100%;
    background: #ffffff;
    border: 1px solid #ebe9f1;
    border-radius: 5px;
  }

  .detail__text--name {
    color: #5e5873;
    font-weight: 600;
    font-size: 14px;
  }

  .detail__text--detail {
    white-space: pre-wrap;
    word-break: break-word;
    max-width: 650px;
  }

  .detail__text--detail,
  .detail__text--datetime {
    color: #6e6b7b;
    font-size: 14px;
  }

  .detail__text--datetime {
    min-width: 140px;
  }

  .detail__text--attachment {
    color: #7367f0;
    font-size: 12px;
    text-decoration-line: underline;
    cursor: pointer;
  }

  @media screen and (min-width: 768px) {
    .detail__container {
      width: 650px;
    }
  }
}

section[name="reply-internal"],
section[name="reply-activity"] {
  .reply-detail__container {
    margin: 10px 0 1rem 0;
    padding: 1rem;
    width: 100%;
    background: #ffffff;
    border: 1px dashed rgba(115, 103, 240, 0.4);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      background-color: #f9f9fe;
    }
  }

  .reply-detail__container-disabled {
    margin: 10px 0 1rem 0;
    padding: 1rem;
    width: 100%;
    background: #ffffff;
    border: 1px dashed #c9ccd1;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .reply-detail-add__container {
    margin: 10px 0 1rem 0;
    width: 100%;
  }

  .reply-detail__text {
    margin-left: 10px;
    color: #7367f0;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
  }

  .reply-detail__text-disabled {
    margin-left: 10px;
    color: #c9ccd1;
    font-weight: 600;
    font-size: 12px;
  }

  .text-disabled {
    color: #c9ccd1;
  }

  .reply-detail__select-file {
    margin: 10px 0 0 0;
  }

  .reply-detail__sent-to {
    margin: 10px 0 0 0;
  }

  .sent-to__container {
    display: flex;
    flex-direction: column;
  }

  .sent-to__text-sent-to {
    min-width: 215px;
    font-size: 12px;
    color: #6e6b7b;
  }

  .sent-to__state {
    margin: 10px 0 0 0;
  }

  .sent-to__text-department,
  .sent-to__text-person {
    min-width: 100px;
    color: #6e6b7b;
    font-size: 12px;
  }

  .reply-detail__button {
    margin: 10px 0 0 0;
    display: flex;
    justify-content: flex-end;
  }

  @media screen and (min-width: 768px) {
    .reply-detail__container,
    .reply-detail__container-disabled,
    .reply-detail-add__container {
      width: 650px;
    }

    .sent-to__container {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.add__button {
  margin-right: 10px;
}
</style>
